module.exports = __webpack_public_path__ + "media/maps/share-0c39f6c0.svg";